import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface ManagingEditor {
    _id: string;
    fullName: string;
    email: string;
}

interface ManagingEditorContextType {
    managingEditor: ManagingEditor | null;
    token: string | null;
    isAuthenticated: boolean;
    logout: () => void;
    loading: boolean;
}

const ManagingEditorContext = createContext<ManagingEditorContextType>({
    managingEditor: null,
    token: null,
    isAuthenticated: false,
    logout: () => { },
    loading: true
});

export const useManagingEditor = () => useContext(ManagingEditorContext);

export const ManagingEditorProvider = ({ children }: { children: ReactNode }) => {
    const [managingEditor, setManagingEditor] = useState<ManagingEditor | null>(null);
    const [token, setToken] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedToken = localStorage.getItem('managingEditorToken');
        const storedManagingEditor = localStorage.getItem('managingEditorData');

        if (storedToken && storedManagingEditor) {
            setToken(storedToken);
            setManagingEditor(JSON.parse(storedManagingEditor));
        }

        setLoading(false);
    }, []);

    const logout = () => {
        localStorage.removeItem('managingEditorToken');
        localStorage.removeItem('managingEditorData');
        setManagingEditor(null);
        setToken(null);
        // This role is embedded as a tab inside the unified dashboard, so logging out
        // here should return to the unified login, not this role's standalone one.
        window.location.href = '/login';
    };

    return (
        <ManagingEditorContext.Provider value={{
            managingEditor,
            token,
            isAuthenticated: !!token && !!managingEditor,
            logout,
            loading
        }}>
            {children}
        </ManagingEditorContext.Provider>
    );
};
